import {BehaviorSubject, Observable, Subject, Subscription} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {JdDyFormComponent} from './dy-form.component';
import {
  JdDyContent,
  JdDyFormAllowInputByChange,
  JdDyFormOptionItem, JdDyFormSubmitOrRest
} from './dy-form.interface';
import {isArray, isObject, includes, isString} from 'lodash';
import {format} from 'date-fns';
import {FocusKeyManager} from "@angular/cdk/a11y";
import {FormFocusDirective} from "./form-focus.directive";
import {takeUntil} from "rxjs/operators";

const allowInputByChange = [
  'isShowButton',
  'breakpointOptions',
  'controlBreakpointOptions',
  'submitButton',
  'restButton',
  'isInline',
  'isByDepWidthDoResponsive',
  'isGroup',
  'size',
  'isVertical',
  'loadingTip',
  'loading',
];

export class JdDyForm {
  private _option: JdDyFormOptionItem[] = [];
  private _unsubscribe$ = new Subject();
  private _optionMap = new Map<string, JdDyFormOptionItem>();

  isGetSelectLabelName = false;

  isAutoFillSelectContent = false;

  set submitButton(value: JdDyFormSubmitOrRest) {
    JdDyForm.toAsync(() => this.formKeyChange({submitButton: value}));
  }

  set restButton(value: JdDyFormSubmitOrRest) {
    JdDyForm.toAsync(() => this.formKeyChange({restButton: value}));
  }

  set isInline(value: boolean) {
    JdDyForm.toAsync(() => this.formKeyChange({isInline: value}));
  }

  set size(value: 'default' | 'small' | 'large') {
    JdDyForm.toAsync(() => this.formKeyChange({size: value}));
  }

  set isGroup(value: boolean) {
    JdDyForm.toAsync(() => this.formKeyChange({isGroup: value}));
  }

  set loading(value: boolean) {
    JdDyForm.toAsync(() => this.formKeyChange({loading: value}));
  }

  set loadingTip(value: string) {
    JdDyForm.toAsync(() => this.formKeyChange({loadingTip: value}));
  }

  set isByDepWidthDoResponsive(value: boolean) {
    JdDyForm.toAsync(() => this.formKeyChange({isByDepWidthDoResponsive: value}));
  }

  set isShowButton(value: boolean) {
    JdDyForm.toAsync(() => this.formKeyChange({isShowButton: value}));
  }

  set isVertical(value: boolean) {
    this.__init((dyForm) => {
      const data: any = {
        isVertical: value,
      };
      if (!dyForm.column) {
        data['column'] = 24;
      }
      JdDyForm.toAsync(() => this.formKeyChange(data));
    });
  }

  readonly formFieldChange$ = new BehaviorSubject<{
    [key: string]: JdDyFormOptionItem[] | any;
  }>(null);
  readonly setFormValue$ = new BehaviorSubject<{ [key: string]: string }>({});
  // çå¬å¨æè¡¨åçFormGroup  ä¸è¬ç¨æ¥è·åè¡¨åFormGroupçå®ä¾
  readonly formGroup$ = new Subject<FormGroup>();
  // çå¬å¨æè¡¨åç»ä»¶  ä¸è¬ç¨æ¥è·åè¡¨åçå®ä¾
  readonly formComponent$ = new Subject<JdDyFormComponent>();
  readonly formToApiHelp$ = new BehaviorSubject<{ [key: string]: any }>({});
  readonly formKeyChange$ = new BehaviorSubject<JdDyFormAllowInputByChange>({});
  // çå¬è¡¨åå¼çæ¹å
  readonly valueChanges$ = new Subject();
  // çå¬æäº¤æé®
  readonly OnSubmit$ = new Subject<FormGroup>();
  // çå¬éç½®æé®
  readonly OnRest$ = new Subject<FormGroup>();

  readonly OpenChange$ = new Subject<{ isOpen: boolean, key: string, isNeedLoading: boolean }>();
  // åå§å
  readonly OnInit$ = new Subject<FormGroup>();
  readonly OnInputBlur$ = new Subject<string>();
  // çå¬æç´¢æé®
  readonly OnSearch$ = new Subject<{ [key: string]: any }>();
  // çå¬åè½¦
  readonly OnEnter$ = new Subject<{ key: string, event: KeyboardEvent }>();
  readonly OnSuffixAction$ = new Subject<{ name: string; $event: Event }>();
  // çå¬è¡¨æ ¼æ°æ®çåå
  readonly OnTableSelectChange$ = new Subject<{ [key: string]: any }>();

  readonly OnNotSearchResult$ = new Subject<{ name: string, isNeedLoading: boolean, value: string }>();

  // è·åè¡¨åç»ç dyFormå®ä¾
  readonly formGroupDyForm$ = new Subject<{[key: string]: JdDyForm}>();

  readonly initState: JdDyFormAllowInputByChange;

  private __initInterval = null;

  /*getFormGroupDyForm(formGroupName: string): Observable<JdDyForm> {
    return Observable.create(ob => {
      this.__init((dyForm) => {
        ob.next(dyForm.formGroupDyForm[formGroupName]);
        ob.complete();
      })
    });
  }*/

  valueChangesByKey<T = any>(key: string): Observable<T> {
    return this.dyFormGroup.controls[key].valueChanges;
  }

  get valid(): boolean {
    return this.dyFormGroup ? this.dyFormGroup.valid : false;
  }

  get value() {
    this.getValue(this.dyFormComponent);
    return this.dyFormGroup ? this.dyFormGroup.value : {};
  }

  dyFormGroup: FormGroup = null;

  dyFormComponent: JdDyFormComponent = null;

  private __init(callBack: (dyForm: JdDyFormComponent) => void) {
    if (this.dyFormComponent) {
      callBack(this.dyFormComponent);
    } else {
      if (this.__initInterval) {
        return;
      }
      this.__initInterval = setInterval(() => {
        if (this.dyFormComponent) {
          callBack(this.dyFormComponent);
          clearInterval(this.__initInterval);
        }
      });
    }
  }
  insert(item: JdDyFormOptionItem[] | JdDyFormOptionItem, keyOrIndex?: string | number): this {
    if (!keyOrIndex && keyOrIndex !== 0) {
      keyOrIndex = null;
    }
    if (!isArray(item)) {
      item = [item];
    }

    this.__init((dyForm) =>  dyForm.addOptions(keyOrIndex, ...<JdDyFormOptionItem[]>item));
    // this.dyFormComponent.addOptions(keyOrIndex, ...item);
    return this;
  }

  set option(value: JdDyFormOptionItem[]) {
    if (JSON.stringify(this._option) !== JSON.stringify(value)) {
      this._option = value;
      this.initFormOptions(value);
    }
  }

  get option(): JdDyFormOptionItem[] {
    return this._option;
  }

  get keyManager(): FocusKeyManager<FormFocusDirective> {
    return this.dyFormComponent.keyManager;
  }

  static toAsync(callBack: Function) {
    setTimeout(() => callBack());
  }

  selectContentIsExit(key: string): boolean {
    const _config = this.getConfigByKey(key);
    if (!_config) return false;
    if (_config.selectConfig && _config.selectConfig.content) {
      const _content = _config.selectConfig.content;
      if (!_content.length || (_content.length === 1 && _content[0].preMark)) {
        return false;
      } else if (_content.length) return true;
    }
    return false;
  }

  getOptionBykey(key: string): JdDyFormOptionItem {
    return this._optionMap.get(key);
  }

  disabledByKeys(keys: string[] | string): this {
    this._disabledOrEnabled(keys, true);
    return this;
  }

  enabledByKeys(keys: string[] | string): this {
    this._disabledOrEnabled(keys, false);
    return this;
  }

  updateSelectContentByKey(key: string, value: JdDyContent[]): this {
    this.updateField([{
      name: key,
      selectConfig: {content: value}
    }]);
    return this;
  }

  updateRadioContentByKey(key: string, value: JdDyContent[]): this {
    this.updateField([{
      name: key,
      radioConfig: {content: value}
    }]);
    return this;
  }

  updateSelectContentsByKeys(key: string[], value: JdDyContent[][]): this {
    const options = [];
    key.forEach((value1, index) => {
      options.push({
        name: value1,
        selectConfig: {content: value[index]}
      })
    });
    this.updateField(options);
    return this;
  }

  getConfigByKey(key: string): JdDyFormOptionItem {
    const _controls = this.dyFormComponent.controlArray;
    for (let control of _controls) {
      if (control.name === key) return control;
    }
    return null;
  }

  restNotCheck(value?: any, options?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
  }): this {
   /* const _controls = this.dyFormComponent.controlArray, _values: { [key: string]: null } = {};
    _controls.forEach(value1 => _values[value1.name] = null);
    this.setValues(_values);*/
    this.__init(dyForm => dyForm.reset(value, options));
    return this;
  }

  getSelectContentByKey(key: string): JdDyContent[] {
    const _control = this.dyFormComponent.controlArray;
    for (const jdDyFormOptionItem of _control) {
      if (jdDyFormOptionItem.name === key) {
        return jdDyFormOptionItem.selectConfig.content
      }
    }
  }

  private _disabledOrEnabled(keys: string[] | string, enabled: boolean) {
    const _updateField = [];
    if (isArray(keys)) {
      keys.forEach(value1 => {
        _updateField.push({name: value1, disabled: enabled});
      });
    } else if (isString(keys)) {
      _updateField.push({name: keys, disabled: enabled});
    }
    this.updateField(_updateField);
  }

  getValue(formGroup: JdDyFormComponent) {
    const _options = formGroup.controlArray,
      oldValue = formGroup.formArea.value;
    const temp: { [key: string]: JdDyFormOptionItem } = {};
    const select: { [key: string]: JdDyFormOptionItem } = {};
    _options.forEach(value => {
      if (includes(['timePicker', 'datePicker', 'rangePicker'], value.type)) {
        temp[value.name] = value;
      }
      if (includes(['select'], value.type)) {
        select[value.name] = value;
      }
    });
    for (let selectKey in select) {

      if (this.isGetSelectLabelName) {
        let labelName = select[selectKey].selectConfig.labelName;
        if (labelName === false) {
          continue;
        }
        labelName = labelName ? labelName : selectKey + '_name';
        const content = select[selectKey].selectConfig.content;

        for (let item of content) {
          let __value: any = '';
          if (isString(item.value) && item.value.indexOf('~') > -1) {
            __value = item.value.split('~')[0];
          } else {
            __value = item.value;
          }
          if (__value === oldValue[selectKey]) {
            oldValue[labelName as any] = item.label;
            break;
          }
        }
      }

    }

    for (const tempKey in temp) {
      const _key = temp[tempKey].name;
      if (temp[tempKey].type === 'timePicker') {
        oldValue[_key] = oldValue[_key] ? format(oldValue[_key], temp[tempKey].pickerConfig.timeFormat) : null;
      } else if (temp[tempKey].type === 'datePicker') {
        oldValue[_key] = oldValue[_key] ? format(oldValue[_key], temp[tempKey].pickerConfig.dataFormat) : null;
      } else if (temp[tempKey].type === 'rangePicker' && oldValue[_key] && oldValue[_key].length === 2) {
        oldValue[_key][0] = format(oldValue[_key][0], temp[tempKey].pickerConfig.dataFormat);
        oldValue[_key][1] = format(oldValue[_key][1], temp[tempKey].pickerConfig.dataFormat);
      }
    }
  }

  markValid(): this {
    this.formFieldChange$.next({markValid: true});
    return this;
  }

  setSelectLoading(key: string, isLoading: boolean = true): this {
    JdDyForm.toAsync(() => this.formFieldChange$.next({isLoading: {[key]: isLoading}}));
    return this;
  }

  private validInput(options: JdDyFormAllowInputByChange) {
    if (!isObject(options) || isArray(options)) {
      throw Error(`Parameter error: key --- ${options} must to be a object`);
    }
    Object.keys(options).every(value => {
      if (allowInputByChange.indexOf(value) > -1) {
        return true;
      }
      throw Error(
        `Parameter error: key --- ${value} Not allowed to be modified`
      );
    });
  }

  /**
   * æ¹åå¨æè¡¨åå±æ§ ï¼å¤ä¸ªï¼
   * @param options
   */
  formKeyChange(options: JdDyFormAllowInputByChange): this {
    this.validInput(options);
    this.formKeyChange$.next(options);
    return this;
  }

  setLoading(isLoading: boolean, loadingTip: string): this {
    JdDyForm.toAsync(() => this.formKeyChange({loadingTip: loadingTip, loading: isLoading}));
    return this;
  }

  /**
   * æ´æ°æ§ä»¶
   * @param item
   */
  updateField(item: JdDyFormOptionItem[] | JdDyFormOptionItem): this {
    if (!isArray(item)) item = [item];
    JdDyForm.toAsync(() => this.formFieldChange$.next({update: item}));
    return this;
  }

  /**
   * æ°å¢æ§ä»¶
   * @param item
   */
  addField(item: JdDyFormOptionItem[] | JdDyFormOptionItem): this {
    if (!isArray(item)) item = [item];
    JdDyForm.toAsync(() => this.formFieldChange$.next({add: item}));
    return this;
  }

  /**
   * ç§»é¤æå®æ§ä»¶
   * @param formControlName æ§ä»¶åç§°
   */
  removeField(formControlName: string | string[]): this {
    JdDyForm.toAsync(() =>
      this.formFieldChange$.next({remove: formControlName})
    );
    return this;
  }

  /**
   * è®¾ç½®æ§ä»¶çå¼
   * @param value : key => value object
   */
  setValues(value?: { [key: string]: any }): this {
    this.setFormValue$.next(value);
    return this;
  }

  /**
   * åå§åå¨æè¡¨å
   * @param item
   */
  initFormOptions(item: JdDyFormOptionItem[]): this {
    this.formFieldChange$.next({formOptions: item});
    return this;
  }

  constructor(option?: JdDyFormOptionItem[], initState?: JdDyFormAllowInputByChange) {
    this.option = option ? option : [];
    this.initState = initState;
    this.formToApiHelp$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => {
        if (value && value.formGroup) {
          this.dyFormGroup = value.formGroup;
          this.formGroup$.next(value.formGroup);
        }
        if (value && value.formComponent) {
          this.dyFormComponent = value.formComponent;
          this._optionMap = (value.formComponent as JdDyFormComponent).controlMap;
          this.formComponent$.next(value.formComponent);
        }
      });
  }

  destroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
